<template>
    <div :class="adicionarClasses(tamanhoJanela.x)">
        <button class="analise-menu__mobile-botao"
                @click="expandirMenu">
            <i class="fas fa-bars mr-1" aria-hidden="true"/>
            <small>Menu</small>
        </button>

        <p class="analise-menu__titulo">Documentos anexados</p>

        <span v-if="this.value.documentosAnalizaveis.length === 0"
                    class="aviso">
            <ul class="analise-menu__lista">
                <li class="analise-menu__lista-item">
                    Nenhum documento encontrado
                </li>
            </ul>
        </span>

        <ul class="analise-menu__lista">
            <li v-for="(documento, index) in value.documentosAnalizaveis"
                :key="index"
                :class="{ active: documentoEstaSelecionado && indiceDocumentoSelecionado === index && listagemSelecionada === 'LISTAGEM_DOCUMENTOS_ANEXADOS'}"
                class="analise-menu__lista-item"
                @click="selecionarDocumento(documento, index, 'LISTAGEM_DOCUMENTOS_ANEXADOS')">
                {{ documento.descricao }}
                <span v-if="['Em Analise','Reanálise'].includes(situacaoCompraDireta)">
                    <v-tooltip right v-if="documento.situacao === 'ANALISADO'">
                        <div slot="activator">
                            <i class="icone fas fa-check-circle" aria-hidden="true"/>
                        </div>
                        Documento Analisado
                    </v-tooltip>

                    <span v-if="documento.situacao === 'AGUARDANDO_REENVIO'"
                          class="aviso">
                        Aguardando<br>Reenvio
                        <i class="fas fa-exclamation-circle ml-2 icone" aria-hidden="true"/>
                    </span>

                    <span v-if="documento.situacao === 'AGUARDANDO_ENVIO'"
                          class="aviso">
                        Aguardando<br>Envio
                        <i class="fas fa-clock ml-2 icone" aria-hidden="true"/>
                    </span>
                </span>
            </li>
        </ul>

        <p class="analise-menu__titulo">Relatórios</p>

        <ul class="analise-menu__lista">
            <li v-for="(documento, index) in value.documentosNaoAnalizaveis"
                :key="index"
                :class="{ active: documentoEstaSelecionado && indiceDocumentoSelecionado === index && listagemSelecionada === 'LISTAGEM_RELATORIOS'}"
                class="analise-menu__lista-item"
                @click="selecionarDocumento(documento, index, 'LISTAGEM_RELATORIOS')">
                {{ documento.descricao }}
            </li>
        </ul>

        <botao-baixar-todos
            :deshabilitar="!deveHabilitarBotaoBaixarTodos"
            colorClass="primary-color"
            texto="Baixar Todos"
            class="botao-baixar-todos analise-menu__lista-item"
            @baixarTodosDocumentos="baixarTodosDocumentos"/>
    </div>
</template>

<script>
import BotaoBaixarTodos from '@/views/components/BotaoBaixarTodos.vue'

export default {
    name: 'AnaliseDocumentacaoMenu',
    components:{BotaoBaixarTodos},
    props: {
        value: {
            type: Object,
            required: true
        },
        situacaoCompraDireta: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            documentosAnexados: [],
            relatorios: [],
            situacao: null,
            documentoEstaSelecionado: false,
            indiceDocumentoSelecionado: 0,
            listagemSelecionada: 'LISTAGEM_DOCUMENTOS_ANEXADOS',
            tamanhoJanela: {
                x: 0,
                y: 0
            },
            menuEstaAberto: false
        }
    },
    created() {
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
    },
    computed: {
        docsAnalise() {
            const base = this.value || {}
            return {
                analizaveis: Array.isArray(base.documentosAnalizaveis) ? base.documentosAnalizaveis : [],
                naoAnalizaveis: Array.isArray(base.documentosNaoAnalizaveis) ? base.documentosNaoAnalizaveis : []
            }
        },
        deveHabilitarBotaoBaixarTodos(){
            return this.docsAnalise.analizaveis.every(this.ehDocumentoAnalisado)
        }
    },
    mounted() {
        if (this.verificarSeExisteDocumentos())
            this.selecionarDocumentoInicial()
    },
    methods: {
        selecionarDocumento(documento, index, listagem) {
            this.documentoEstaSelecionado = true
            this.indiceDocumentoSelecionado = index
            this.listagemSelecionada = listagem
            if (['Em Analise','Reanálise'].includes(this.situacaoCompraDireta) && documento.situacao === 'NAO_ANALISADO') {
                this.$emit('documentoSelecionado', {
                    documento: documento,
                    novaSituacao: 'ANALISADO'
                })
            } else {
                this.$emit('documentoSelecionado', {
                    documento: documento,
                    novaSituacao: null
                })
            }
            if (this.tamanhoJanela.x <= 720) {
                this.expandirMenu()
            }
        },
        handleResize () {
            this.tamanhoJanela = {
                x: window.innerWidth,
                y: window.innerHeight
            }
        },
        adicionarClasses(largura) {
            if (largura <= 720 && this.menuEstaAberto) {
                return 'analise-menu analise-menu__mobile analise-menu__mobile-aberto'
            } else if(largura <= 720 && !this.menuEstaAberto) {
                return 'analise-menu analise-menu__mobile analise-menu__mobile-fechado'
            } else {
                return 'analise-menu'
            }
        },
        expandirMenu() {
            this.menuEstaAberto = !this.menuEstaAberto
        },
        verificarSeExisteDocumentos() {
            return this.value.documentosAnalizaveis.length > 0 || this.value.documentosNaoAnalizaveis.length > 0
        },
        selecionarDocumentoInicial() {
            if (this.value.documentosAnalizaveis.length > 0) {
                this.selecionarDocumento(this.value.documentosAnalizaveis[0], 0, 'LISTAGEM_DOCUMENTOS_ANEXADOS')
            } else {
                this.selecionarDocumento(this.value.documentosNaoAnalizaveis[0], 0, 'LISTAGEM_RELATORIOS')
            }
        },
        baixarTodosDocumentos(){
            this.$emit('baixarTodosDocumentos')
        },
        ehDocumentoAnalisado(documento){
            return documento.situacao === 'ANALISADO'
        }
    },
    watch: {
        tamanhoJanela: {
            handler() {
                this.adicionarClasses(this.tamanhoJanela.x)
            }
        }
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    }
}
</script>

<style scoped lang="stylus">
    .analise-menu
        width 20%
        background-color #eaeaea
        max-height calc(100vh - 136px)
        overflow-y auto
        height calc(100vh - 136px)
        /*position relative*/

        &__titulo
            margin-bottom 0
            padding 14px 10px 10px
            background-color #a5a5a5
            height 44px
            text-align center
            text-transform uppercase
            color #fff
            font-size 12px
            font-weight bold

        &__lista
            padding-left 0
            font-size 12px

            &-item
                padding 20px 20px 20px 13px
                border-bottom 1px solid #a5a5a5
                color #555
                display flex
                justify-content space-between
                align-items center

            &-item:hover, &-item:focus, &-item:active
                background-color #dbdbdb !important
                cursor pointer

            &-item .icone
                color var(--v-primary-base)
                font-size 13px
                margin-left 5px

            .active
                color #fff
                background-color var(--v-primary-base)

            .active:hover, .active:focus, .active:active
                background-color var(--v-primary-darken1) !important

            .active::after
                content ''
                position absolute
                border-top 10px solid transparent
                border-bottom 10px solid transparent
                border-right 15px solid #f8f9fa
                left 19%

            .active .icone, .active .aviso, .active .aviso .icone
                color #fff

            .aviso
                color #ed8732
                display flex
                align-items center
                font-size 10px
                text-align right
                line-height 10px
                margin-left 5px

            .aviso .icone
                color #ed8732

        &__mobile
            z-index 1
            position absolute

            &-botao
                display none
                width 100%
                padding 10px
                color #777

            &-botao:hover, &-botao:active, &-botao:focus
                background-color #eee

            &-aberto
                width 70%

            &-fechado
                width 20%
                height 40px !important

    .botao-baixar-todos
        border-top 1px solid #a5a5a5
        position absolute
        bottom 20px
        display block
        width 20%
        text-align center
        font-size 16px
        font-weight bold
        padding 15px 10px

    @media only screen and (min-width 1400px)
        .analise-menu__lista .active::after
            left 19.2%

    @media only screen and (min-width 1600px)
        .analise-menu__lista .active::after
            left 19.4%

    @media only screen and (max-width 950px)
        .analise-menu__titulo
            font-size 11px

    @media only screen and (max-width 785px)
        .analise-menu__titulo
            font-size 10px

    @media only screen and (max-width 720px)
        .analise-menu
            &__mobile-botao
                display block

            &__mobile-aberto &__titulo
                width 100%
                padding-top 15px

            &__lista .active::after
                right 0
                left auto
                border-top 8px solid transparent
                border-bottom 8px solid transparent
                border-right 10px solid #f8f9fa

            &__lista-item
                padding 13px

</style>
